<template>
  <header>
    <div id="global-top-nav-region">
      <div class="sfi-static-header">
        <div class="container sfi-static-header-content">
          <logo class="generic-logo" :imgMarginTop="logoMarginTop" :imgWidth="logoWidth"></logo>
          <p class="contact" v-if="insuranceType.contactUsLink">
            <a :href="insuranceType.contactUsLink" :name="analyticsConstants.CONTACT_US">
              <i class="material-icons phone">phone</i>
              <p> Contact Us </p>
            </a>
          </p>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
// Utils
import { mapGetters, mapState } from 'vuex';

// Constants
import constants from '@/i18n/en/constants';

export default {
  name: 'SfiHeader',
  data() {
    return {
      analyticsConstants: constants.analyticsConstants,
      logoPosition: constants.logoPosition
    }
  },
  computed: {
    ...mapState(['insuranceType']),
    ...mapGetters({
      insuranceIsSfm: 'GET_IS_INSURANCE_SFM'
    }),
    logoMarginTop() {
      return this.logoPosition[this.insuranceType.key].header.marginTop;
    },
    logoWidth() {
      return this.logoPosition[this.insuranceType.key].header.width;
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables.scss';

#global-top-nav-region {

  box-shadow: 0px 10px 40px 0px rgba(0,0,0,0.25);

  .sfi-static-header {
    background: linear-gradient(180deg, $sfi-header-primary-color 0%, #00559B 100%);
    height: 60px;
  }

  .sfi-static-header-content {
    max-width: $sfi-max-header-and-footer-width;
    margin: auto;

    @include breakpoint(small only) {
      margin-left: 20px;
      margin-right: 20px;
    }

    @include breakpoint(medium only) {
      margin-left: 34px;
      margin-right: 34px;
    }

    .generic-logo {
      display: inline-block;
    }

    p.contact {
      margin-top: 20px;
      margin-bottom: 19px;
      font-size: 14px;
      float: right;

      a {
        color: $white;
        display: inline-flex;
        font-weight: 600;
      }

    }

    .material-icons.phone {
      font-size: 18px;
      color: $secondary-color;
      margin-right: 4px;
      margin-top: 2px;
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/components/shared/sfi-header.vue